module.exports = __webpack_public_path__ + "static/img/130.c0131a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/130.png
// module id = dGW2
// module chunks = 0